<template lang="html">
  <section class="float-wrap">
    <div class="float-floor" :style="`visibility: ${entryInfo.needShowEntry? 'visible' : 'hidden'}`">
      <a @click.prevent="clickHandler(entry)"
        data-actionid="8"
      >
        <img v-if="entryInfo.needShowEntry" :src="picHost+entry.iconLink"/>
      </a>
    </div>
    <div class="go-top" :style="`visibility: ${goTopShow? 'visible' : 'hidden'}`" @click="goTop">
      <i class="go-top-icon" :style="`background-image: url('${baseUrl}static/imgs/top-btn.png')`"></i>
    </div>
  </section>
</template>
<script>
/**
 * 这里主要是返回顶部。
*/
import { throttle } from '@/utils/index'
import sendLog from '@/utils/q_log'

export default {
  data() {
    return {
      goTopShow: false,
      scrollTop: ''
    }
  },
  props: {
    entryInfo: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    entry() {
      return this.entryInfo.info || {}
    }
  },
  created() {
    this._throttle = throttle(16, this.needScroll).bind(this)
    window.addEventListener('scroll', this._throttle, false)
  },
  methods: {
    needScroll() {
      let clientHeight = document.documentElement.clientHeight || document.body.clientHeight
      this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      if (this.scrollTop >= clientHeight) {
        this.goTopShow = true
      } else {
        this.goTopShow = false
      }
    },
    goTop() {
      const logParam = {
        actPos: '-1_1',
        actPage: `cms_${this.$root.promotionId}`,
        actText: `cms_${this.$root.promotionId}_goTop`
      }
      sendLog(logParam)
      window.scrollTo(0, 0)
    },
    async clickHandler(entry) {
      if (process.env.VUE_APP_LOCAL === 'Q') {
        const logParam = {
          actPos: '-1_1',
          actPage: `cms_${this.$root.promotionId}`,
          actText: `cms_${this.$root.promotionId}_topBtn`
        }
        sendLog(logParam)
        const { openScheme, getQueryString } = require('@/utils/q_business')
        const url = entry.webEntryLink || entry.entryLink
        const title = getQueryString('title', url)
        openScheme(url, 'navibar-normal', title)
      } else {
        const platform = await this.getEnv()
        if (platform === 2) {
          // 跳转APP
          window.location.href = entry.APPEntryLink
        } else if (platform === 1 && this.tjChannelId === 'tujia') {
          // 跳转小程序
          wx.miniProgram.navigateTo({
            url: entry.WXEntryLink
          })
        } else {
          // 跳转web
          window.location.href = entry.webEntryLink
        }
      }
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this._throttle, false)
  }
}
</script>
<style lang="scss" scoped>
.float-wrap {
  position: fixed;
  bottom: 6.666rem;
  right: 0.6666rem;
  z-index: 99;
  width: 3rem;

  .float-floor {
    width: 100%;

    a {
      display: block;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .go-top {
    margin-top: 1.6666rem;
    width: 3rem;
    height: 3rem;
    border-radius: 50%;
    .go-top-icon {
      background-size: 100% 100%;
      background-repeat: no-repeat;
      width: 100%;
      height: 100%;
      display: inline-block;
      background-position: center;
    }
  }
}
</style>
